import type { TSliderModalProps } from './loadable';

export type TCompareFlightSlides = TSliderModalProps['slides'];

export const SLIDES_CONFIG_KEY = 'Newbuilding.CompareFlightTrap.Slides';

export const SLIDES_DEFAULT: TCompareFlightSlides = [
  {
    type: 'info',
    imageUrl: 'https://static.cdn-cian.ru/frontend/newbuilding-b2c-assets/compare-flight/1.png',
    title: 'Встречайте сравнение ЖК',
    description: 'Нажимайте плюс — соберём таблицу с выводами в разделе «Сравнение»',
  },
  {
    type: 'info',
    imageUrl: 'https://static.cdn-cian.ru/frontend/newbuilding-b2c-assets/compare-flight/2.png',
    title: 'Таблица со всем важным',
    description: 'Цены, метраж, что есть на территории и многое другое',
  },
  {
    type: 'info',
    imageUrl: 'https://static.cdn-cian.ru/frontend/newbuilding-b2c-assets/compare-flight/3.png',
    title: 'Итоги сравнения от ИИ',
    description: 'Подчеркнём отличия и особенности',
  },
];
